import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18ea3477"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom -inner" }
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "大会スタッフログイン", -1))
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = { class: "global-unit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "event",
  class: "global-label"
}, "大会選択", -1))
const _hoisted_8 = { class: "global-select -large" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: ""
}, "大会を選択してください", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "global-unit" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "userId",
  class: "global-label"
}, "アカウントID", -1))
const _hoisted_13 = { class: "global-unit" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "global-label"
}, "パスワード", -1))
const _hoisted_15 = { class: "submitButton" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "ログイン", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                class: "select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userForm.topic_id) = $event)),
                name: "",
                id: "event"
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics.list, (topic) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: topic.id,
                    value: topic.id
                  }, _toDisplayString(topic.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.userForm.topic_id]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "userId",
              class: "global-input -large",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.id) = $event))
            }, null, 512), [
              [_vModelText, _ctx.userForm.id]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              class: "global-input -large",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userForm.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.userForm.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "global-button",
              disabled: !_ctx.isFormCompleted,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
            }, _hoisted_19, 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ]))
}